export default __webpack_public_path__ + "static/media/logo-extensivos-2023.2d92a29d.svg";